import { useState, useEffect } from "react";
import { useSettingsContext } from "../../hooks/settings/SettingsContext";
import Furigana from "../furigana";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import Button from "@mui/material/Button";

const Cards = ({ hidden, vocabularyList, word, result, setExercises, setStep }) => {
  const { furigana } = useSettingsContext();

  const [way, setWay] = useState(true);
  const [question, setQuestion] = useState(null);
  const [choices, setChoices] = useState(null);
  const [answer, setAnswer] = useState(null);

  const shuffle = (list) =>
    list
      .map((value) => ({ value, sort: Math.random() }))
      .toSorted((a, b) => a.sort - b.sort)
      .map(({ value }) => value);

  useEffect(() => {
    setWay(Math.random() < 0.5);
    setQuestion(word);
    let traps = vocabularyList.filter((d) => d.type === word.type && d !== word);
    let list = shuffle(traps).slice(0, 5);
    list.splice((6 * Math.random()) | 0, 0, word);
    setChoices(list);
  }, [vocabularyList, word]);

  return (
    <Box
      sx={{
        height: "550px",
        width: "100%",
        display: hidden ? "none" : "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography variant="h6" gutterBottom>
        Comment dit-on cela en {way ? "Français" : "Japonais"} ?
      </Typography>
      <Chip label={question ? way ? <Furigana furigana={furigana} center text={question["japanese"]} /> : question["french"].join(", ") : ""} sx={{ height: "50px", width: "400px" }} />
      <DoubleArrowIcon sx={{ margin: "10px", rotate: "90deg" }} />
      <Stack
        direction="row"
        sx={{
          justifyContent: "center",
          flexWrap: "wrap",
          width: "400px",
          gap: 1,
        }}
      >
        {choices?.map((choice, index) => {
          return (
            <Chip
              key={`exercise${index}`}
              variant={answer === choice ? "filled" : "outlined"}
              label={choice ? !way ? <Furigana furigana={furigana} center text={choice["japanese"]} /> : choice["french"].join(", ") : ""}
              onClick={() => setAnswer(choice)}
              sx={{
                height: "50px",
                width: "400px",
                ...(result !== null && choice === answer ? { backgroundColor: "red" } : {}),
                ...(result !== null && choice === word ? { backgroundColor: "green" } : {}),
              }}
              disabled={result !== null}
            />
          );
        })}
      </Stack>
      <Box
        sx={{
          width: "90%",
          maxWidth: "500px",
          margin: "10px 0",
          display: "flex",
          justifyContent: "end",
        }}
      >
        <Button variant="text" onClick={() => setExercises((exs) => exs.map((ex) => (ex.word !== word ? ex : { ...ex, result: answer === word })))} disabled={answer === null} hidden={result !== null}>
          Valider
        </Button>
        <Button variant="text" onClick={() => setStep((s) => s + 1)} hidden={result === null}>
          Suivant
        </Button>
      </Box>
    </Box>
  );
};

export default Cards;
